import { ClipLoader } from 'react-spinners';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import history from '../browserHistory';
import { useNavigate } from 'react-router';

type TProps = {
  color?: string;
  isLoading?: boolean;
  url?: string;
  onClick?: () => void;
  dataCy?: string;
};

export const SkipButton = ({
  color = colors.secondary[500],
  isLoading = false,
  url,
  onClick,
  dataCy,
}: TProps) => {
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (onClick) {
      onClick();
    } else if (url) {
      history.push(url);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      className="button-reset"
      style={{
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        width: 'fit-content',
      }}
      type="button"
      onClick={handleOnClick}
      data-cy={dataCy}
    >
      {isLoading ? (
        <ClipLoader size={24} color={color} loading={isLoading} />
      ) : (
        <Typography as="span" bold color={color} variant="body1">
          Skip
        </Typography>
      )}
    </button>
  );
};
